import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import {
  type StatementSearch,
  statementSearchFrom,
} from '@/features/accounting-reports/monthly-statements-api'
import { ProfitAndLossScreen } from '@/features/accounting-reports/profit-and-loss-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/reports/profit-and-loss')({
  validateSearch: (search: Record<string, unknown>): StatementSearch => statementSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: ProfitAndLossRoute,
})

function ProfitAndLossRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <ProfitAndLossScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/accounting/reports/profit-and-loss', search: next })
      }
    />
  )
}
